// Robust mock-data til Grundejerforeningen Kongeengen

export const defaultDocuments = [
  // Vedtægter
  {
    title: "Vedtægter for Grundejerforeningen Kongeengen",
    year: 2023,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/vedtaegter-2023.pdf",
    category: "vedtaegter"
  },

  // Generalforsamling
  {
    title: "Referat Generalforsamling 2026 (underskrevet)",
    year: 2026,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/referat-generalforsamling-2026-underskrevet.pdf",
    category: "generalforsamling"
  },
  {
    title: "Referat Generalforsamling 2025 (underskrevet)",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/referat-generalforsamling-2025-underskrevet.pdf",
    category: "generalforsamling"
  },
  {
    title: "Generalforsamling 2024",
    year: 2024,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/generalforsamling-2024.pptx",
    category: "generalforsamling"
  },
  {
    title: "Referat Generalforsamling 2023",
    year: 2023,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/referat-2023-signed-1.pdf",
    category: "generalforsamling"
  },
  {
    title: "Referat Ordinær Generalforsamling 2022",
    year: 2022,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/2022-ordinaer-generalforsamling.pdf",
    category: "generalforsamling"
  },
  {
    title: "Referat Ordinær Generalforsamling 2021",
    year: 2021,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/2021-ordinaer-generalforsamling.pdf",
    category: "generalforsamling"
  },
  {
    title: "Referat Ordinær Generalforsamling 2019",
    year: 2019,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/2019-ordinaer-generalforsamling.pdf",
    category: "generalforsamling"
  },

  // Økonomi
  {
    title: "Regnskab 2025",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/regnskab-2025.pdf",
    category: "oekonomi"
  },

  // Bestyrelsesmøder
  {
    title: "Bestyrelsesmøde 05-08-2026",
    year: 2026,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-05-08-2026_1c779ba0.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 03-06-2026",
    year: 2026,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-03-06-2026.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 01-04-2026",
    year: 2026,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-01-04-2026.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 04-02-2026",
    year: 2026,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-04-02-2026.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 19-12-2025",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-19-12-2025.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 01-10-2025",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-01-10-2025.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 20-08-2025",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-20-08-2025.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 11-06-2025",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-11-06-2025.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 02-04-2025",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-02-04-2025.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 05-02-2025",
    year: 2025,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-05-02-2025.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 04-12-2024",
    year: 2024,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-04-12-2024.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 02-10-2024",
    year: 2024,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-02-10-2024.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 14-08-2024",
    year: 2024,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-14-08-2024.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 05-06-2024",
    year: 2024,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-05-06-2024.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 03-04-2024",
    year: 2024,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-03-04-2024.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 10-01-2024",
    year: 2024,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-10-01-2024.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 08-11-2023",
    year: 2023,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-08-11-2023.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 20-09-2023",
    year: 2023,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-20-09-2023.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 24-05-2023",
    year: 2023,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-24-05-2023.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 08-03-2023",
    year: 2023,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-08-03-2023.pdf",
    category: "bestyrelsesmoede"
  },
  {
    title: "Bestyrelsesmøde 11-01-2023",
    year: 2023,
    file_url: "https://assets.auxodev.dk/assets/08244d25-ccef-47e3-a520-4ba58dea7d97/bestyrelsesmoede-11-01-2023.pdf",
    category: "bestyrelsesmoede"
  }
];

export const defaultEvents = [
  {
    id: "event-sommerfest-2026",
    title: "Sommerfest på Fællesarealet",
    date: "2026-08-15",
    time: "14:00 - 22:00",
    location: "Det store grønne fællesareal v/ Legepladsen",
    description: "Vi gentager succesen og inviterer alle beboere i Kongeengen til den årlige sommerfest! Der vil være hoppeborg til børnene, fælles grill (foreningen sørger for kul og telt), og kolde drikkevarer kan købes til foreningsvenlige priser. Medbring selv kød/tilbehør samt service og godt humør.",
    image: ["https://cdn.brick.site/6866696df3ec584b07678dee/original/image_1c95fe22bd184192b0b2e137f1f67fad"],
    status: "kommende"
  },
  {
    id: "event-arbejdsdag-2026",
    title: "Fælles Arbejdsdag & Hygge",
    date: "2026-09-19",
    time: "09:30 - 14:00",
    location: "Mødested ved Legepladsen",
    description: "Lad os stå sammen om at gøre vores dejlige område endnu smukkere. Vi skal luge ukrudt, reparere hegn, give legepladsen en kærlig hånd og plante nye buske. Foreningen serverer rundstykker og kaffe från morgenstunden, og vi slutter af med en velfortjent øl/vand og pølser fra grillen kl. 13:00.",
    image: ["https://cdn.brick.site/6866696df3ec584b07678dee/original/image_406691c7cf7149089fb9dcf30e4a85ce"],
    status: "kommende"
  },
  {
    id: "event-fastelavn-2026",
    title: "Fastelavnsfest for Børnene",
    date: "2026-02-22",
    time: "11:00 - 13:00",
    location: "Fællesarealet (ved teltet)",
    description: "Kom udklædt og vær med til at slå katten af tønden! Vi kårer kattedronninger og kattekonger i forskellige aldersgrupper. Der vil være fastelavnsboller, varm kakao til børnene og kaffe til de voksne.",
    image: ["https://cdn.brick.site/6866696df3ec584b07678dee/original/image_1c95fe22bd184192b0b2e137f1f67fad"],
    status: "afholdt"
  }
];

export const defaultBoardMembers = [
  {
    name: "Kern Holm Thomsen",
    role: "Formand",
    address: "Kongevænget 84",
    phone: "2255-8863",
    email: "Kongeengen@gmail.com",
    sort_order: 1
  },
  {
    name: "Christian Toft Madsen",
    role: "Kasserer",
    address: "Kongevænget",
    phone: "",
    email: "",
    sort_order: 2
  },
  {
    name: "Mikael Skrydstrup",
    role: "Bestyrelsesmedlem",
    address: "Kongstedgårds Alle",
    phone: "",
    email: "",
    sort_order: 3
  },
  {
    name: "Ann-katrine",
    role: "Bestyrelsesmedlem",
    address: "Kongstedgårds Alle",
    phone: "",
    email: "",
    sort_order: 4
  },
  {
    name: "Morten Jessen",
    role: "Bestyrelsesmedlem",
    address: "Kongevænget",
    phone: "",
    email: "",
    sort_order: 5
  },
  {
    name: "Daniel Haurum Kristensen",
    role: "Suppleant",
    address: "Kongevænget",
    phone: "",
    email: "",
    sort_order: 6
  },
  {
    name: "Christian Revell",
    role: "Suppleant",
    address: "Kongevænget",
    phone: "",
    email: "",
    sort_order: 7
  }
];

export const defaultGallery = [
  {
    title: "Det grønne fællesareal",
    description: "Vores store, åbne fællesareal med plads til leg og boldspil.",
    image: "https://cdn.brick.site/6866696df3ec584b07678dee/original/image_1c95fe22bd184192b0b2e137f1f67fad"
  },
  {
    title: "Legepladsen",
    description: "Legepladsen er det naturlige samlingspunkt for områdets børn.",
    image: "https://cdn.brick.site/6866696df3ec584b07678dee/original/image_406691c7cf7149089fb9dcf30e4a85ce"
  },
  {
    title: "Naturstien",
    description: "Smukke stier der forbinder boligområdet med den omkringliggende natur.",
    image: "https://cdn.brick.site/6866696df3ec584b07678dee/original/image_1c95fe22bd184192b0b2e137f1f67fad"
  }
];
